import { createPrefixedConstants } from 'app/common/CommonUtils';

export default createPrefixedConstants(
  'opensource',
  `
    SET_OPENSOURCE_SORT

    UPDATE_OPENSOURCE_FILTER
    SET_OPENSOURCE_FILTER
    CLEAR_OPENSOURCE_FILTER
  `
);
